import { useRef } from "react";
import { LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AutoTradingAdminUnlock = ({ busy, error, configured, onLogin }) => {
  const passwordRef = useRef(null);
  const submit = async (event) => {
    event.preventDefault();
    let password = passwordRef.current?.value || "";
    if (passwordRef.current) passwordRef.current.value = "";
    await onLogin(password);
    password = null;
  };
  return <section className="admin-unlock ph-no-capture" data-ph-no-capture="true" data-testid="auto-trading-admin-unlock">
    <div className="unlock-icon"><LockKeyhole aria-hidden="true" /></div>
    <div><p className="eyebrow">受保护的交易配置</p><h2>管理员解锁</h2>
      <p>解锁后可配置 OKX Demo API。交易所凭证不会保存在浏览器。</p></div>
    <form onSubmit={submit} autoComplete="off" data-ph-no-capture="true" data-testid="admin-login-form">
      <label htmlFor="auto-admin-password">管理员密码</label>
      <input id="auto-admin-password" ref={passwordRef} type="password" required
        autoComplete="off" data-lpignore="true" data-1p-ignore="true"
        data-ph-no-capture="true"
        data-testid="admin-password-input" />
      <Button type="submit" disabled={busy || !configured} data-testid="admin-login-button">
        <LockKeyhole aria-hidden="true" />解锁
      </Button>
    </form>
    {!configured && <p className="error-text" data-testid="admin-auth-not-configured">管理员安全配置不可用</p>}
    {error && <p className="error-text" data-testid="admin-login-error">{error}</p>}
  </section>;
};